import styled from 'styled-components';

export const TextDiv = styled.div`
  padding: 12px 16px;
  text-align: start;
  border-radius: 6px;
  background: var(--primary-violet-10);
  color: var(--primary-violet-500);
`;
